import * as S from './ParagraphWithTooltip.styled';
import Hightlighter from 'react-highlight-words';

const ParagraphWithTooltip = ({
  text,
  field,
  search,
  isHighlight = false,
  style,
  highlightStyle,
}) => {
  const showToolTip = (event) => {
    const target = event.currentTarget;
    if (target.offsetWidth < target.scrollWidth) {
      target.title = target.textContent;
    }
  };

  const hideTooltip = (event) => {
    const target = event.currentTarget;
    target.title = '';
  };

  return (
    <S.Text
      style={{ ...style }}
      onMouseEnter={showToolTip}
      onMouseLeave={hideTooltip}
      field={field}
    >
      {isHighlight ? (
        <Hightlighter
          textToHighlight={text}
          searchWords={[search]}
          highlightTag='strong'
          highlightStyle={highlightStyle}
        />
      ) : (
        <>{text}</>
      )}
    </S.Text>
  );
};

export default ParagraphWithTooltip;
